import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getOrganizationAdmin($id: String!) {
    getOrganizationAdmin(id: $id) {
      id
      name
      email
      mobile
      photo
      systemUser {
        username
        name
      }
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.UserState = {
  result: null,
  error: null,
  loading: false
};

export const getOrganizationAdminRequest = createAsyncThunk<
  TYPES.User,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'user/get_organization_admin',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getOrganizationAdmin;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getOrganizationAdminSlice = createSlice({
  name: 'get_organization_admin',
  initialState: initialState,
  reducers: {
    getOrganizationAdminClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getOrganizationAdminRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(getOrganizationAdminRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(getOrganizationAdminRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { getOrganizationAdminClear } =
getOrganizationAdminSlice.actions;

export const getOrganizationAdmin = createSelector(
  (state: RootState) => state.user.getOrganizationAdmin.result,
  (state: RootState) => state.user.getOrganizationAdmin.error,
  (state: RootState) => state.user.getOrganizationAdmin.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getOrganizationAdminSlice.reducer;